import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { Navbar } from "@/components/Navbar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import { SectionStep } from "@/components/coaching/SectionStep";
import { ContactStep } from "@/components/coaching/ContactStep";
import { SECTIONS, EMPTY, toPayload } from "@/lib/coaching";
import { api, formatError } from "@/lib/api";

const Done = () => (
  <div data-testid="coaching-success" className="py-10">
    <CheckCircle2 size={40} className="text-[#c4dcca]" />
    <h2 className="mt-6 font-display text-5xl font-900 uppercase leading-[0.9] md:text-7xl">Grazie!<br /><span className="text-[#c4dcca]">Ti ricontatterò entro breve.</span></h2>
    <Link to="/training-online" data-testid="coaching-success-back-link" className="mt-10 inline-block font-mono text-xs uppercase tracking-widest text-[#a3b1aa] underline hover:text-[#c4dcca]">Torna al training online</Link>
  </div>
);

export default function CoachingCheckup() {
  const [form, setForm] = useState(EMPTY);
  const [step, setStep] = useState(0);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const total = SECTIONS.length + 1;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [step, done]);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/coaching/checkup", toPayload(form));
      setDone(true);
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <main data-testid="coaching-checkup-page" className="min-h-screen">
      <Navbar />
      <CartDrawer />
      <div className="mx-auto max-w-3xl px-5 pb-24 pt-28 md:pt-36">
        {done ? <Done /> : (
          <>
            <div className="mb-10 flex items-center justify-between">
              <button type="button" data-testid="coaching-back-btn" onClick={() => setStep((s) => Math.max(0, s - 1))} disabled={step === 0}
                className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-[#a3b1aa] hover:text-[#c4dcca] disabled:opacity-30">
                <ArrowLeft size={14} /> Indietro
              </button>
              <span data-testid="coaching-progress" className="font-mono text-xs uppercase tracking-widest text-[#98bfa2]">Primo passo · Anamnesi · {step + 1}/{total}</span>
            </div>
            <div className="mb-10 h-1 bg-white/10"><div className="h-full bg-[#98bfa2] transition-[width] duration-500" style={{ width: `${((step + 1) / total) * 100}%` }} /></div>
            {step < SECTIONS.length
              ? <SectionStep s={SECTIONS[step]} form={form} set={set} onNext={() => setStep((x) => x + 1)} />
              : <ContactStep form={form} set={set} onSubmit={submit} sending={sending} />}
          </>
        )}
      </div>
      <Footer />
    </main>
  );
}
